import { PostEventTrack } from '../domain/dtos'

export const makePostEventData = (data: PostEventTrack) => ({
  userId: data.userId,
  productId: data.productId,
})
